document.addEventListener("DOMContentLoaded", function () {
    gsap.set('.co-fu-s2-frame .z-ani-o', { opacity: 0, y: 40 });
    let cFUS2Tl1 = gsap.timeline({ paused: true });
    cFUS2Tl1.to('.co-fu-s2-frame .z-ani-o', {
        y: 0,
        scale: 1,
        opacity: 1,
        duration: 1,
        stagger: 0.2,
        ease: "power2.inOut"
    }, "-=0.9");
    ScrollTrigger.create({
        trigger: '.co-fu-s2-frame .z-ani-o',
        start: "40% bottom",
        end: "bottom top",
        animation: cFUS2Tl1
    });
});